"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

/**
 * Root layout failure boundary. App Router replaces the root layout with this
 * component, so it must render its own <html> and <body>. Styles are inline
 * because the app shell (and any CSS it loads) may already be broken.
 */
export default function GlobalError({ error, reset }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100dvh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          fontFamily:
            'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          background: "#fafafa",
          color: "#171717",
        }}
      >
        <div style={{ maxWidth: 420, textAlign: "center" }}>
          <h1
            style={{
              margin: "0 0 12px",
              fontSize: 22,
              fontWeight: 600,
              lineHeight: 1.3,
            }}
          >
            Something went wrong
          </h1>
          <p
            style={{
              margin: "0 0 24px",
              fontSize: 15,
              lineHeight: 1.5,
              color: "#525252",
            }}
          >
            We have been notified and are looking into it. You can try again.
          </p>
          <button
            type="button"
            onClick={() => {
              if (typeof reset === "function") reset();
            }}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              border: 0,
              borderRadius: 9999,
              background: "#171717",
              color: "#ffffff",
              padding: "12px 24px",
              fontSize: 14,
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
